import { ButtonHTMLAttributes } from 'react'

export type ButtonProps = {
  text: string
  variant?: ButtonVariant
  className?: string
  loading?: boolean
} & ButtonHTMLAttributes<HTMLButtonElement>

export type ButtonVariant = 'solid' | 'outlined'

export default function Button({
  text,
  variant = 'solid',
  onClick,
  className,
  loading = false,
  disabled,
  ...rest
}: ButtonProps) {
  return (
    <button
      className={`px-5 py-3 md:px-8 md:py-4 text-base md:text-lg transition ${className || ''} ${
        loading || disabled
          ? 'opacity-50 cursor-not-allowed'
          : 'hover:bg-[#333] cursor-pointer'
      } ${
        variant === 'outlined'
          ? 'border border-[#545457] text-[#545457] hover:text-white'
          : 'bg-[#545457] text-white'
      }`}
      onClick={onClick}
      disabled={loading || disabled}
      {...rest}
    >
      {loading ? (
        <span className="inline-flex items-center gap-2">
          <svg
            className="animate-spin h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
            />
          </svg>
          {text}
        </span>
      ) : (
        text
      )}
    </button>
  )
}
